import { FC } from 'react'
import Image from 'next/image'

import styles from './sidebar.module.scss'

interface ISidebarTop {
  title: string
  iconData: any
  setDates?: (dates: Date[]) => void
  btnBackHandler?: () => void
}

const SidebarTop: FC<ISidebarTop> = ({
  title,
  iconData,
  setDates,
  btnBackHandler,
}: ISidebarTop) => {
  const clearDate = () => {
    setDates && setDates([])
  }

  return (
    <div className={styles.sidebarTop}>
      <button className={styles.sidebarTopButton} onClick={btnBackHandler}>
        <Image {...iconData} />
        <span className={styles.text}>{title}</span>
      </button>
      {setDates && (
        <button className={styles.sidebarTopButton} onClick={clearDate}>
          <span className={styles.resetText}>Сбросить</span>
        </button>
      )}
    </div>
  )
}

export default SidebarTop
